/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { a as __rest, _ as __assign } from '../../../tslib.es6-e01eabb2.js';

function uploadFile(params, context) {
    var _a, _b;
    // 菜鸟钉 h5 ref: https://open.dingtalk.com/document/orgapp/upload-objects-jsapi
    if (params.fileType !== 'image') {
        (_a = params === null || params === void 0 ? void 0 : params.fail) === null || _a === void 0 ? void 0 : _a.call(params, {
            errMsg: 'Only supports images',
        });
        return;
    }
    var api = 'dd.biz.util.uploadFile';
    (_b = context.DDCall) === null || _b === void 0 ? void 0 : _b.call(context, api, params, {
        formatInput: function (input) {
            var fileName = input.fileName, other = __rest(input, ["fileName"]);
            return __assign(__assign({}, other), { name: fileName });
        },
    });
}

export { uploadFile as default };
